export class RequiredParent {
  constructor(public readonly name: string, public readonly fields: any[]) {}

  addFieldValue(value: any): void {
    this.fields.push(value);
  }
}
